"use client";

import React from "react";

import useMedicationFormCard from "./useMedicationFormCard.jsx";
import MedicationFormCardView from "./MedicationFormCardView.jsx";

export default function MedicationFormCard({

  form,

  index,

  total,

  onRemove,

  onFieldChange,

  onTogglePreview,

  onFetchDrugInfo,

  isPreviewActive,

  prescriptionId,

  initialMedications,

  scriptNumber,

  isFromDispensaryMenu,

  pharmacyInfo, // Add pharmacyInfo prop
  user, // Add user prop
  drugInfo, // Add drugInfo prop
  showRepeat = false, // Add showRepeat prop with default false
  repeatData = null, // Add repeatData prop with default null
  repeatNumber = null,

}) {

  const hook = useMedicationFormCard({
    form,
    onFieldChange,
    onFetchDrugInfo,
    isPreviewActive,
    prescriptionId,
    initialMedications,
    scriptNumber,
    isFromDispensaryMenu,
    pharmacyInfo,
    user,
    drugInfo,
    showRepeat,
    repeatData,
    repeatNumber,
  });

  return (
    <MedicationFormCardView
      form={form}
      index={index}
      total={total}
      onRemove={onRemove}
      onFieldChange={onFieldChange}
      onTogglePreview={onTogglePreview}
      onFetchDrugInfo={onFetchDrugInfo}
      isPreviewActive={isPreviewActive}
      prescriptionId={prescriptionId}
      scriptNumber={scriptNumber}
      isFromDispensaryMenu={isFromDispensaryMenu}
      directionsOptions={hook.directionsOptions}
      formatPatientNameForDisplay={hook.formatPatientNameForDisplay}
      rxNumbers={hook.rxNumbers}
      selectedPatient={hook.selectedPatient}
      medications={hook.medications}
      selectedRxNumber={hook.selectedRxNumber}
      icd10Codes={hook.icd10Codes}
      selectedMedication={hook.selectedMedication}
      isMedicationInItemTable={hook.isMedicationInItemTable}
      setSelectedPatient={hook.setSelectedPatient}
      setSelectedRxNumber={hook.setSelectedRxNumber}
      setSelectedMedication={hook.setSelectedMedication}
      setIcd10Codes={hook.setIcd10Codes}
      setIsMedicationInItemTable={hook.setIsMedicationInItemTable}
      handlePrint={hook.handlePrint}
      showRepeat={hook.showRepeat}
    />
  );
}
